import { render, staticRenderFns } from "./ListUserRole.vue?vue&type=template&id=1f79556f"
import script from "./ListUserRole.vue?vue&type=script&lang=js"
export * from "./ListUserRole.vue?vue&type=script&lang=js"
import style0 from "./ListUserRole.vue?vue&type=style&index=0&id=1f79556f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports